import { Dispatch, FC, SetStateAction, memo } from 'react';

import { Trans } from 'react-i18next';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { t } from 'tools/i18n';
import { Form, Icon, Label, TextArea, Typography } from 'ui';
import { formRules } from 'utils/formRules';

import { setIsEditingEvent, setSubStep } from 'slices/eventsSlice';
import { useAppDispatch } from 'store/index';

import { EVENT_CREATE_FORM_DETAILS_ENUM } from '../eventCreateFormDetails.utils';
import s from './EventCreateFormDetailsDescription.module.scss';
import { formats, modules } from './eventCreateFormDetailsDescription.utils';

interface EventCreateFormDetailsProps {
  setIsDirty: Dispatch<SetStateAction<boolean>>;
}

const EventCreateFormDetailsDescription: FC<EventCreateFormDetailsProps> = ({ setIsDirty }) => {
  const dispatch = useAppDispatch();

  return (
    <div className={s.wrapper}>
      <Typography type="h3" weight={700}>
        {t('common_description')}
      </Typography>
      <div className={s.form}>
        <div className={s.content}>
          <div>
            <Label>{t('common_summary')}</Label>
            <Form.Item name={EVENT_CREATE_FORM_DETAILS_ENUM.SUMMARY}>
              <TextArea
                onFocus={() => dispatch(setSubStep('DESCRIPTION'))}
                className={s.summary}
                name="summary"
                onChange={() => {
                  setIsDirty(true);
                  dispatch(setIsEditingEvent(true));
                }}
                maxLength={400}
                placeholder="Enter event summary"
              />
            </Form.Item>
          </div>

          <div>
            <Label required>{t('common_full_description')}</Label>
            <Form.Item
              name={EVENT_CREATE_FORM_DETAILS_ENUM.FULL_DESCRIPTION}
              rules={[formRules.required]}
              initialValue={null}>
              <ReactQuill
                theme="snow"
                onKeyDown={() => {
                  dispatch(setIsEditingEvent(true));
                  setIsDirty(true);
                }}
                modules={modules}
                formats={formats}
                className={s.editor}
                placeholder={t('event_create_form_full_description_placeholder')}
              />
            </Form.Item>
          </div>
        </div>
        <div className={s.hintBlock}>
          <div className={s.hint}>
            <div>
              <Icon name="warning" />
            </div>
            <Trans i18nKey="event_create_form_description_first_tip" components={{ b: <b /> }} />
          </div>
          <div className={s.hint}>
            <div>
              <Icon name="warning" />
            </div>
            <Trans i18nKey="event_create_form_description_second_tip" components={{ b: <b /> }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(EventCreateFormDetailsDescription);
